<template>
    <transition :name="transition">
        <div class="snackbar message" v-if="messageVisible">
            <div class="message-header has-background-grey-lighter">{{ newMessage.header }}
                <button @click="messageVisible=false" class="delete"></button>
            </div>
            <div class="message-body">{{ newMessage.body }}</div>
        </div>
    </transition>
</template>

<script>
import {eventBus} from "../../events/event-bus";
import SvgIcon from "../svg/SvgIcon";
import {mapGetters} from "vuex";
import {viewports} from "../../store/constants/viewports";

export default {
    name: "Snackbar",
    components: {SvgIcon},
    data() {
        return {
            messageVisible: false,
            newMessage: {
                type: "danger",
                header: "Hier scheint ein Fehler aufgetreten zu sein",
                body: "Der Server ist aktuell nicht erreichbar. Bitte versuche es zu einem späteren Zeitpunkt erneut."
            }
        }
    },
    computed: {
        ...mapGetters(["screenSize", "currentViewport"]),
        transition() {
            if ([viewports.MOBILE.name, viewports.TABLET.name].includes(this.currentViewport)) {
                return "snackbar-mobile"
            } else {
                return "snackbar"
            }
        }
    },
    methods: {
        showMessage(duration) {
            this.messageVisible = true;
            let vm = this;
            setTimeout(() => {
                vm.messageVisible = false;
            }, duration);
        }
    },
    created() {
        let vm = this;

        eventBus.$on('notification', (message) => {
            vm.newMessage = message;
            vm.showMessage(message.duration ? message.duration : 10000);
        })
    }
}
</script>

<style scoped>

</style>
